import { Fit } from './types'

export const ViewModes: { full: Fit; scroll: Fit } = {
  full: 'full',
  scroll: 'scroll'
}

const skewMargin = 0.995
const Rotations = [0, 90, 180, 270]

export const getRotation = deg => {
  let index = Math.floor(deg / 90) % 4
  if (index < 0) {
    index = 4 + index
  }
  return Rotations[index]
}

export const getBoundingBoxStructured = boundingBox => {
  const unrotated =
    boundingBox[0] < boundingBox[2] * skewMargin &&
    boundingBox[6] < boundingBox[4] * skewMargin &&
    boundingBox[1] < boundingBox[7] * skewMargin &&
    boundingBox[3] < boundingBox[5] * skewMargin
  const rotatedRight =
    boundingBox[6] < boundingBox[0] && boundingBox[1] < boundingBox[3]

  if (unrotated) {
    return {
      topLeftX: boundingBox[0],
      topLeftY: boundingBox[1],
      topRightX: boundingBox[2],
      topRightY: boundingBox[3],
      bottomRightX: boundingBox[4],
      bottomRightY: boundingBox[5],
      bottomLeftX: boundingBox[6],
      bottomLeftY: boundingBox[7]
    }
  }
  if (rotatedRight) {
    return {
      topLeftX: boundingBox[6],
      topLeftY: boundingBox[7],
      topRightX: boundingBox[0],
      topRightY: boundingBox[1],
      bottomRightX: boundingBox[2],
      bottomRightY: boundingBox[3],
      bottomLeftX: boundingBox[4],
      bottomLeftY: boundingBox[5]
    }
  }
  //rotated left
  return {
    topLeftX: boundingBox[2],
    topLeftY: boundingBox[3],
    topRightX: boundingBox[4],
    topRightY: boundingBox[5],
    bottomRightX: boundingBox[6],
    bottomRightY: boundingBox[7],
    bottomLeftX: boundingBox[0],
    bottomLeftY: boundingBox[1]
  }
}
